import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RidButton } from '../../components/rid-button/rid-button';
import { RidDemoPage } from '../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-component-lab-page',
  imports: [RouterLink, RidButton, RidDemoPage],
  templateUrl: './component-lab-page.html',
})
export class ComponentLabPage {}
